import { ActionTree } from 'vuex';
import { UsersState } from './types';
import { RootState } from '@/store/types';
import api from '@/api';
import * as usersRequests from '@/api/requests/users';
import User from '@/api/models/user';
import { SAVE_RELATED_USERS } from '@/api/requests/users';

export const actions: ActionTree<UsersState, RootState> = {
    /**
     * Fetch all users.
     */
    async fetchUsers({ commit }) {
        const response = await api.call(usersRequests.ALL());
        commit('setUsers', response.data.data);
    },

    /**
     * Set vuex users.
     */
    async setUsers({ commit }, users: User[]) {
        commit('setUsers', users);
    },

    /**
     * Create a new user.
     *
     * @param commit
     * @param user
     */
    async createUser({ commit }, user: User) {
        const response = await api.call(usersRequests.SAVE(user.toRequest()));
        commit('addUser', response.data.data);
        return response.data.data.id;

    },

    /**
     * Update an existing user.
     *
     * @param commit
     * @param user
     */
    async updateUser({ commit }, user: User) {
        if (!user.id) {
            throw new Error('No user id provided');
        }
        const response = await api.call(usersRequests.UPDATE(user.id, user.toRequest()));
        commit('addUser', response.data.data);
    },

    /**
     * Set active user.
     *
     * @param commit
     * @param getters
     * @param userId
     */
    async setActiveUser({ commit, getters }, userId: number) {
        const response = await api.call(usersRequests.FIND(userId));
        commit('addUser', response.data.data);
        commit('setActiveUserId', userId);
    },

    /**
     * Fetch all users related.
     */
    async fetchRelatedUsers({ commit }) {
        const response = await api.call(usersRequests.RELATED_USERS());
        commit('setRelatedUsers', response.data.data);
    },

    /**
     * Fetch all available users to be related.
     */
    async fetchAvailableRelatedUsers({ commit }) {
        const response = await api.call(usersRequests.AVAILABLE_RELATED_USERS());
        commit('setAvailableRelatedUsers', response.data.data);
    },
};
